<p-confirmPopup key="confirmPopup"></p-confirmPopup>
<p-confirmDialog #confirmDialog [style]="{width: '400px'}" key="confirmDialog" [baseZIndex]="10000"
  rejectButtonStyleClass="p-button-outlined">
  <p-footer>
    <button *ngFor="let button of dialogExtraButtons" pButton type="button" [label]="button.label"
      [icon]="button.icon" [ngClass]="button.styleClass || 'p-button-text'" (click)="runDialogExtraButton(button)">
    </button>
    <button *ngIf="currentDialogConfirmation?.rejectVisible !== false" pButton type="button"
      [label]="currentDialogConfirmation?.rejectLabel || 'Không'" [icon]="currentDialogConfirmation?.rejectIcon"
      [ngClass]="currentDialogConfirmation?.rejectButtonStyleClass || 'p-button-outlined'"
      (click)="confirmDialog.reject()">
    </button>
    <button *ngIf="currentDialogConfirmation?.acceptVisible !== false" pButton type="button"
      [label]="currentDialogConfirmation?.acceptLabel || 'Có'" [icon]="currentDialogConfirmation?.acceptIcon"
      [ngClass]="currentDialogConfirmation?.acceptButtonStyleClass" (click)="confirmDialog.accept()">
    </button>
  </p-footer>
</p-confirmDialog>
